import { css, cva } from '@/styled-system/css';

export const listingActionGlassForeground = css.raw({
  position: 'relative',
  zIndex: 'zIndexStep',
});

export const listingActionGlass = cva({
  base: {
    backdropFilter: 'blur(token(sizes.effect.blur.200))',
    borderRadius: 'pill',
    boxShadow: 'sm',
    isolation: 'isolate',
    position: 'relative',
    _before: {
      backgroundColor: 'bg.neutral-fixed',
      borderRadius: 'pill',
      content: '""',
      inset: 0,
      opacity: '80',
      pointerEvents: 'none',
      position: 'absolute',
      zIndex: 'zIndexBase',
      _dark: {
        backgroundColor: 'bg.softest',
        opacity: '60',
      },
    },
  },
  variants: {
    layout: {
      cluster: {
        alignItems: 'center',
        flexShrink: 0,
        gap: 'tightest',
        paddingBlock: 'tightest',
        paddingInline: 'tightest',
        '& > :where(a, button)': {
          _hover: {
            backgroundColor: 'bg.action.bare.neutral.hover',
          },
          _active: {
            backgroundColor: 'bg.action.bare.neutral.pressed',
          },
        },
      },
      control: {
        flexShrink: 0,
        _hover: {
          backgroundColor: 'bg.action.bare.neutral.hover',
        },
        _active: {
          backgroundColor: 'bg.action.bare.neutral.pressed',
        },
      },
      modalFooter: {
        alignItems: 'center',
        background: 'transparent',
        borderTopWidth: 'none',
        bottom: 'default',
        display: 'flex',
        justifyContent: 'center',
        left: '50%',
        padding: 'tighter',
        position: 'absolute',
        right: 'auto',
        top: 'auto',
        transform: 'translateX(-50%)',
        width: 'auto',
        zIndex: 'zIndexOverParent',
      },
    },
    shape: {
      rounded: {
        borderRadius: 'md',
        _before: {
          borderRadius: 'md',
        },
      },
      topRounded: {
        borderTopLeftRadius: 'md',
        borderTopRightRadius: 'md',
        borderBottomRightRadius: 'none',
        borderBottomLeftRadius: 'none',
        _before: {
          borderTopLeftRadius: 'md',
          borderTopRightRadius: 'md',
          borderBottomRightRadius: 'none',
          borderBottomLeftRadius: 'none',
        },
      },
    },
  },
});
